import { IOffersResponse } from "../../../Orchestrator/Types/Index";
import { IFmlmView } from "../../../Orchestrator/Types/Interface/IFmlmView";

export type FmlmViewOffersResponseMapType = Map<string, IOffersResponse>;

export class FmlmViewContext {
  public routeTo: string[] = [];
  public nextTo: string[] = [];
  public selectedFmlmJourney: IFmlmView | null = null;

  constructor() {}
}
